import React from 'react'
import { X } from 'lucide-react'
import type { BudgetSheetState } from '../../../../../services/projectAutofillDraftService.ts'
import ModalOverlay from '../../../../UI/ModalOverlay/ModalOverlay.tsx'
import BudgetSheetEditor from './BudgetSheetEditor/BudgetSheetEditor.tsx'
import type { BudgetSheetReadonlyReason } from '../../../../../utils/conversationalMode/budgetSheetStateUtils.ts'
import styles from './BudgetSheetFullscreenModal.module.scss'

type Props = {
  isOpen: boolean
  onClose: () => void
  rubroTitle: string
  state: BudgetSheetState | undefined | null
  onChange: (next: BudgetSheetState) => void
  readonlyReason: BudgetSheetReadonlyReason
  disabled: boolean
}

const BudgetSheetFullscreenModal: React.FC<Props> = ({
  isOpen,
  onClose,
  rubroTitle,
  state,
  onChange,
  readonlyReason,
  disabled
}) => {
  return (
    <ModalOverlay isOpen={isOpen} onClose={onClose} zIndex={80}>
      <div className={styles.shell}>
        <header className={styles.header}>
          <div className={styles.titleBlock}>
            <h2 className={styles.title}>Planilla de cotización</h2>
            {rubroTitle ? <p className={styles.subtitle}>{rubroTitle}</p> : null}
          </div>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Cerrar planilla">
            <X size={22} strokeWidth={2} aria-hidden />
          </button>
        </header>
        {state ? (
          <div className={`${styles.body} ${styles.bodyDocked}`}>
            <BudgetSheetEditor
              showHeading={false}
              flushLayout
              dockInModal
              state={state}
              onChange={onChange}
              disabled={disabled}
              readonlyReason={readonlyReason}
            />
          </div>
        ) : (
          <div className={styles.emptyBody}>No hay datos de planilla para mostrar.</div>
        )}
      </div>
    </ModalOverlay>
  )
}

export default BudgetSheetFullscreenModal
